// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiBaseUrl: 'https://staging-organiser-api.livepass.in/api/v1',
  // apiBaseUrl: 'https://tikiti-organizer-api.videostech.cloud/api/v1',
  dashboardLoginUrl: 'https://staging-admin.livepass.in/organiser/login',
  
  apiToken: 'a22c1104b79a4e7e6082568b3c004e7a50fbb803b0b7097386648ae762058e89',

  // Google OAuth (Front-end uses Google Identity Services to get an ID token,
  // then exchanges it with backend for app token + user payload).
  googleClientId: '393445265404-hs3pg9gcetco44g9e3rog1rd55dlcfsb.apps.googleusercontent.com',
  googleLoginPath: '/organizers/google-login'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
